const normalizePath = (path) => {
  if (path.startsWith('http')) {
    return path;
  }
  if (path.startsWith('/api')) {
    return path;
  }
  const sanitizedPath = path.startsWith('/') ? path : `/${path}`;
  return `/api${sanitizedPath}`;
};

async function request(path, { method = 'GET', body, headers = {} } = {}) {
  const resolvedPath = normalizePath(path);
  const hasBody = body !== undefined;
  const response = await fetch(resolvedPath, {
    method,
    credentials: 'include',
    headers: {
      ...(hasBody ? { 'Content-Type': 'application/json' } : {}),
      ...headers,
    },
    body: hasBody ? JSON.stringify(body) : undefined,
  });

  let payload;
  const text = await response.text();
  if (text) {
    try {
      payload = JSON.parse(text);
    } catch (err) {
      payload = { message: text };
    }
  } else {
    payload = {};
  }

  if (!response.ok) {
    const error = new Error(payload.error || 'Request failed');
    error.status = response.status;
    throw error;
  }

  return payload;
}

export const getJson = (path, options) => request(path, options);

export const postJson = (path, body, options) =>
  request(path, { method: 'POST', body, ...(options || {}) });
